<template>
  <div class="container1">
    <div class="placehol"></div>
    <!-- {{ $i18n.locale }} -->
    <!-- <div @click="testFn">testFn</div> -->
    <div :class="['box', isMobile ? 'box-300' : 'box-400']">
      <div class="box-in">
        <i class="el-icon-circle-close" @click="goHome"></i>
        <el-skeleton v-if="showSkeleton === 1" />
        <!-- 参数错误 -->
        <template v-else-if="showSkeleton === 2">
          <div class="icon-box">
            <i
              class="el-icon-warning icon-check"
              :class="[isMobile ? 'icon-80px' : 'icon-100px']"
            ></i>
          </div>
          <div class="text-box">
            <p class="pt-20px">{{ $t("successPage.error") }}</p>
          </div>
        </template>
        <template v-else>
          <div class="icon-box">
            <i
              class="el-icon-success icon-check"
              :class="[isMobile ? 'icon-80px' : 'icon-100px']"
              v-if="userInfo.payNum > 0"
            ></i>
            <i
              v-else-if="isPayFail"
              class="el-icon-error icon-check"
              :class="[isMobile ? 'icon-80px' : 'icon-100px']"
            ></i>
            <template v-else>
              <p class="wait1">{{ $t("successPage.wait1") }}</p>
              <i
                class="el-icon-loading icon-check"
                :class="[isMobile ? 'icon-80px' : 'icon-100px']"
              ></i>
            </template>
          </div>
          <div class="text-box">
            <p v-if="userInfo.payNum > 0" class="pt-20px">
              {{ $t("successPage.congratulations") }} {{ userInfo.carModel }}。
            </p>
            <p v-else-if="isPayFail">{{ $t("successPage.unfinished") }}</p>
            <p v-else class="wait">{{ $t("successPage.wait") }}</p>
            <div
              class="btn"
              v-if="userInfo.payNum < 1 && isPayFail"
              @click="dialogVisible2 = true"
            >
              {{ $t("successPage.rePayment") }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- {{ isMobile }} -->
    <!-- <div @click="goHome">dfadf</div> -->
    <!-- <div @click="goHome2">dfadf11</div> -->
    <!-- <div @click="goHome3">dfadf22</div> -->
    <el-dialog
      center
      top="25vh"
      width="330px"
      :show-close="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
    >
      <div class="dialog-box">
        <p class="dialog-text">{{ $t("successPage.toHome") }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("successPage.cancel")
        }}</el-button>
        <el-button type="primary" @click="goHome2">{{
          $t("successPage.confirm")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      center
      top="25vh"
      width="330px"
      :show-close="false"
      :visible.sync="dialogVisible2"
      @close="handleClose"
    >
      <div class="dialog-box">
        <p class="dialog-text">{{ $t("successPage.rePay") }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">{{
          $t("successPage.cancel")
        }}</el-button>
        <el-button type="primary" @click="payStripeCusFn">{{
          $t("successPage.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
let intervalId = null;
import { debounce } from "lodash";
import { payStripeCusApi, icaurCusUserInfoApi } from "@/Api/requestApi";

export default {
  name: "PaymentResult",
  props: {
    isPayFail: Boolean,
  },
  data() {
    return {
      isMobile: false,
      dialogVisible: false,
      dialogVisible2: false,
      userInfo: {
        title: "",
        firstName: "",
        lastName: "",
        carModel: "V27",
        email: "",
        language: "英文",
        // payNum: -1,
        payNum: 1,
        // payNum: "1000",
        phone: "",
      },
      isIos: false,
      showSkeleton: 1,
      v: null,
    };
  },
  mounted() {
    console.log("mounted :>> ");
    // let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    // console.log("不存在 :>> sessionStorage", lang);
    window.addEventListener("resize", debounce(this.handleResize, 200));
    this.handleResize();
    // console.log("this.$route?.query :>> ", this.$route?.query);
    let { v, lang = "zh" } = this.$route?.query;
    // let { v = "VGs3YANZs6H204",lang = "zh" } = this.$route?.query;
    // let { v = "EIpBTFZKP218", lang = "zh" } = this.$route?.query;

    this.$i18n.locale = lang;

    console.log("v :>> ", v);
    this.v = v ? v : null;
    if (v) {
      this.icaurCusUserInfoFn();
    } else {
      this.showSkeleton = 2;
      // this.showSkeleton = 3;
    }

    const userAgent = navigator.userAgent;
    if (/Mac|iPhone|iPod|iPad/.test(userAgent)) {
      this.isIos = true;
    } else {
      this.isIos = false;
    }
  },
  //   onUnmounted(() => {
  //   window.removeEventListener('resize', handleResize);
  // })
  methods: {
    handleResize() {
      if (window.innerWidth < 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    async icaurCusUserInfoFn() {
      const {
        data: { code, data },
      } = await icaurCusUserInfoApi({ strId: this.v });
      if (code == 200) {
        // console.log("code, data, message :>> ", code, data, message);
        this.userInfo = data;
        this.showSkeleton = 3;
        if (data.payNum > 0) {
          clearInterval(intervalId);
        } else if (!this.isPayFail) {
          clearInterval(intervalId);
          intervalId = setInterval(() => {
            this.icaurCusUserInfoFn();
          }, 5000);
        }
      } else {
        if (!this.isPayFail) {
          clearInterval(intervalId);
          intervalId = setInterval(() => {
            this.icaurCusUserInfoFn();
          }, 5000);
        }

        this.showSkeleton = 2;
      }
    },
    goHome() {
      this.dialogVisible = true;
    },
    goHome2() {
      let { lang = "zh" } = this.$route?.query;
      this.$router.push({ path: "/survey", query: { lang: lang } });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$message(this.$t("successPage.Cancelled"));
    },
    async payStripeCusFn() {
      let { id, language, carModel } = this.userInfo;
      let lang = "zh";
      if (["English", "英文"].includes(language)) {
        lang = "en";
      }
      const {
        data: { code, data },
      } = await payStripeCusApi({
        lang: lang,
        klmRegId: id,
        brand: "icaur",
        carModel: carModel,
      });
      if (code == 200) {
        if (this.isIos) {
          window.location.href = data.url;
        } else {
          window.open(data.url, "_self");
        }
      }
    },
    // handleClose2() {
    //   this.dialogVisible2 = false;
    //   this.$message(this.$t("successPage.Cancelled"));
    // },
  },
  beforeDestroy() {
    clearInterval(intervalId);
  },
};
</script>

<style lang="scss" scoped>
.icon-80px {
  font-size: 80px;
}
.icon-100px {
  font-size: 100px;
}
// .el-message-box {
//   width: 330px !important;
// }
// ::v-deep .el-message-box {
//   width: 330px !important;
// }
.container1 {
  height: 100vh;
  text-align: center;
  position: relative;
  // background-color: #f5f5f5;
  // ::v-deep .el-dialog {
  //   border-radius: 10px !important;
  //   background: none !important;
  //   background-color: rgba(000, 000, 000, 0.6) !important;
  // }
  .placehol {
    height: calc(100% - 61px - 91px);
  }
  .box {
    position: absolute;
    top: 40%;
    left: 50%;
    // padding: 30px;
    transform: translate(-50%, -50%);
    max-width: 510px;
    padding: 45px 30px 45px;
    // padding: 45px 30px 65px;
    border-radius: 8px;
    // box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    background-color: #fff;
    box-shadow: 0px 7px 30px 0px rgba(100, 100, 111, 0.2);
    .box-in {
      position: relative;
    }
    .el-icon-circle-close {
      position: absolute;
      top: -40px;
      right: -25px;
      font-size: 25px;
      cursor: pointer;
    }
    .pt-20px {
      padding-top: 20px;
    }
    .icon-check {
      // font-size: 100px;
      // font-size: 60px;
      font-weight: 600;
      color: #85ce61;
    }
    .el-icon-error {
      color: #f56c6c;
    }
    .el-icon-warning {
      color: #f56c6c;
    }
    .el-icon-loading {
      color: #ccc;
    }
    // ------------------------ 手机，小屏**start ------------------------
    .success-mobile {
      padding-top: 15px;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }

    // ------------------------ 手机，小屏**end ------------------------
    .success {
      padding-top: 16px;
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      color: #333;
    }

    .icon-box {
      // max-width: 90px;
      margin: 0px auto 10px;
      // color: #78c440;
      .wait1 {
        // padding-top: 20px;
        padding-bottom: 30px;
        font-size: 22px;
        line-height: 33px;
        // font-weight: 600;
      }
    }

    .text-box {
      // text-align: left;
      > p {
        font-size: 18px;
        line-height: 30px;
      }
      .btn {
        margin: 40px auto 0;
        padding: 0px 10px;
        display: inline-block;
        // width: ;
        // margin-top: 40px;
        border-radius: 5px;
        line-height: 36px;
        cursor: pointer;
        text-align: center;
        border: #f1f1f1 solid 1px;
        text-decoration: underline;
        font-size: 12px;
      }
      .wait {
        padding-top: 20px;
        font-size: 16px;
      }
    }
  }
  .box-300 {
    width: 330px;
  }
  .box-400 {
    width: 410px;
  }
}
.dialog-box {
  text-align: center;

  .dialog-text {
    font-size: 18px;
    line-height: 30px;
    word-break: keep-all;
  }
}
.el-button--primary {
  border-color: #000 !important;
  background-color: #000 !important;
}
</style>
